import memoize from 'transmute/memoize';
import { getStatus, getData } from './getters';
import { STARTED } from '../constants/recipientKeyConstants';

/**
 * @deprecated use `conversations-async-data/async-data/operators/statusComparators` instead
 */
export const isRecipientLoading = memoize(recipient => !getData(recipient) && getStatus(recipient) === STARTED);